import { useNavigate } from "react-router-dom";
import { MenuTop } from '../../../components/menu/top/menu-top';
import IconButtonComponent from "../../../components/Icon/icon-button";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BusinessIcon from '@mui/icons-material/Business';
import '../styles/causale-page.css';
import { useTranslation } from '../../../shared/i18n/i18n-context';
import { PageBreadcrumb } from '../../../components/page-breadcrumb/page-breadcrumb';

export const CausalePage = () => {
    const navigate = useNavigate();
    const { t } = useTranslation('admin');
    const { t: menuT } = useTranslation('menu');
    
    return (
        <div>
            <MenuTop />
            <div className="causale-page-container">
                <PageBreadcrumb
                    items={[
                        { label: menuT('home'), to: '/home' },
                        { label: t('causalePanel') }
                    ]}
                />
                <h1>{t('causalePanel')}</h1>
                
                <div className="causale-buttons-container">
                    <IconButtonComponent
                        label={t('listUsers')}
                        icon={<PersonAddIcon />}
                        onClick={() => navigate('/admin-painel/users')}
                    />
                    <IconButtonComponent
                        label={t('manageTests')}
                        icon={<AssignmentIcon />}
                        onClick={() => navigate('/admin-painel/tests-management')}
                    />
                    <IconButtonComponent
                        label={t('companies')}
                        icon={<BusinessIcon />}
                        onClick={() => navigate('/admin-painel/companies-dashboard')}
                    />
                </div>
            </div>
        </div>
    );
}
